import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '../security/auth.service';
import { ApplicationUser } from '../security/applicationUser';
import { catchError, switchMap, take } from 'rxjs/operators';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // take(1): user$ is a BehaviorSubject — without completing, a later login/logout emission
    // would re-run switchMap and re-issue the in-flight request.
    return this.authService.user$
      .pipe(
        take(1),
        switchMap(user => {
          if (user) {
            request = request.clone({
              setHeaders: {
                Authorization: this.authService.getAuthorizationHeaderValue()
              }
            });
          }
          return next.handle(request).pipe(
            catchError((error: unknown) => {
              // A 401 on a request that carried a token means the session expired server-side
              // (tokens live 120 minutes): clear it and send the user back to sign in, instead
              // of silently replaying the dead token on every call.
              if (user && error instanceof HttpErrorResponse && error.status === 401) {
                this.handleExpiredSession(user);
              }
              return throwError(() => error);
            }));
        }));
  }

  private handleExpiredSession(user: ApplicationUser): void {
    this.authService.clearSession();
    if (this.authService.isClaimant(user)) {
      // Claimants sign in via their emailed link route; reloading lets the route guards
      // re-evaluate and redirect to the claimant login.
      window.location.reload();
    } else {
      this.router.navigate(['/account/login'], { queryParams: { returnUrl: this.router.url } });
    }
  }
}
